import { Textarea } from "../../ui/textarea";
import { Button } from "../../ui/button";

interface WrittenThoughtProps {
  thought: string;
  onThoughtChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export function WrittenThought({
  thought,
  onThoughtChange,
  onSave,
  onCancel
}: WrittenThoughtProps) {
  return (
    <div className="space-y-4">
      <Textarea
        placeholder="Type your thought here..."
        value={thought}
        onChange={(e) => onThoughtChange(e.target.value)}
        className="min-h-[120px] resize-none text-base focus:ring-2 focus:ring-blue-500 border-gray-300 rounded-lg"
      />
      <div className="flex justify-end gap-3 mt-6">
        <Button 
          variant="outline" 
          onClick={onCancel}
          className="px-6 rounded-full"
        >
          Cancel
        </Button>
        <Button 
          onClick={onSave} 
          disabled={!thought.trim()}
          className="px-6 bg-blue-600 hover:bg-blue-700 rounded-full"
        >
          Save
        </Button>
      </div>
    </div>
  );
}